// This level logic is mostly implemented by Konstantin

import GameSceneImage from '../../Inamove/Components/GameSceneImage/GameSceneImage'
import { levelActionCreator, LevelActionsAction } from '../../Inamove/Components/Level'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import Config from '../../Inamove/Containers/Config'
import { createInteractableObjectListener } from '../../Inamove/Components/InteractableObject'
import Video from '../../Inamove/Components/Video/Video'
import { delay } from '../../KUtil/help'
import LoadingController from '../../Inamove/Controllers/LoadingController'
import dispatch from '../../Inamove/Utility/dispatchAction'

const levelId = 'level14'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    InventoryContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const level = await LevelController.loadLevel(levelId)

    //Konstantin
    //definitions
    let Eingabe = ''
    const code = '2426389' // **DER CODE**
    let graffities_angesehen = 0
    const mind_graffities_angesehen = 0 //zu 0 setzen, falls Spieler code erraten kann
    const tastenDelayInms = 300 //Wie lange bleiben Tasten gedrückt? -> fühlt sich gut an, könnte kürzer sein
    const maxLength = 7 //maximale Zeichen Codeschloss;

    //codeschloss Meldungen:
    const richtig = 'Willkommen!'
    const falsch = 'Falsch!'
    const zuLang = 'Fehler!'

    const unerreichbar = 'Wow!'

    //Eastereggs (Zahl = eingegebener Code für die Meldungen, codes müssen trotzdem in checkEingabe() einprogrammiert sein)
    const easterEgg_80085 = 'Sehr erwachsen'
    const easterEgg_1234567 = 'Na klar...'
    const easterEgg_8335 = 'NOT THE BEES!!'
    const easterEgg_1337 = 'Of course!'
    //load images

    const K356_taste_0 = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/0.png')
    const K356_taste_1 = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/1.png')
    const K356_taste_2 = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/2.png')
    const K356_taste_3 = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/3.png')
    const K356_taste_4 = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/4.png')
    const K356_taste_5 = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/5.png')
    const K356_taste_6 = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/6.png')
    const K356_taste_7 = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/7.png')
    const K356_taste_8 = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/8.png')
    const K356_taste_9 = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/9.png')
    const K356_taste_C = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/c.png')
    const K356_taste_E = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/pfeil.png')

    //Load video & audio ressources
    const buttonClick1 = AudioController.add(
        Config.GAME_SCENE_PATH + 'K356/audio/codeschloss-klick-druecken' + Config.AUDIO_FILE_EXT
    )
    const buttonClick2 = AudioController.add(
        Config.GAME_SCENE_PATH + 'K356/audio/codeschloss-klick-loslassen' + Config.AUDIO_FILE_EXT
    )

    const CodeSchlossOverlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K356/K356-overlay-effekt.png')
    LoadingController.addToQueue(CodeSchlossOverlay)
    level.gameScenes.K356.addImage(CodeSchlossOverlay)

    //richtiger Video hier einsetzen
    const final_Video = new Video(Config.CINEMATIC_PATH + 'V13' + Config.VIDEO_FILE_EXT)
    ;[
        K356_taste_0,
        K356_taste_1,
        K356_taste_2,
        K356_taste_3,
        K356_taste_4,
        K356_taste_5,
        K356_taste_6,
        K356_taste_7,
        K356_taste_8,
        K356_taste_9,
        K356_taste_C,
        K356_taste_E,
        final_Video,
    ].forEach(LoadingController.addToQueue)

    //display erstellen (in css K356-display anpassen!)
    const display = document.createElement('div')
    display.classList.add('K356-display')
    level.gameScenes.K356.element.appendChild(display)

    level.gameScenes.K356.hideInteractableObject('schloss')

    //functions

    /*Fügt eingegebene Taste zur Eingabe hinzu
        "e" bestätigt Eingabte
        "c" löscht Eingabe
        bei Eingaben > maxLength gibt es fehler + eingabe wird gelöscht
    */
    let gesperrt = false
    async function eingabe(taste: string, img: GameSceneImage) {
        if (!gesperrt) {
            AudioController.play(buttonClick1)
            if (taste != 'e' && taste != 'c') {
                Eingabe += taste
                if (Eingabe.length > maxLength) {
                    setDisplay(zuLang)
                    Eingabe = ''
                } else {
                    setDisplay(Eingabe)
                }
            } else if (taste == 'e') {
                checkEingabe()
            } else if (taste == 'c') {
                Eingabe = ''
                setDisplay(Eingabe)
            } else {
                //Fallback
                setDisplay(unerreichbar)
                eingabe('c', K356_taste_C)
            }

            //Sperre weitere Eingabe bis der Knopf losgelassen wird
            gesperrt = true
            level.gameScenes.K356.addImage(img)

            //Knopf bleibt tastenDelayInms (Millisekunden) gedrückt
            await delay(tastenDelayInms)

            //Entsperre Eingabe
            gesperrt = false
            AudioController.play(buttonClick2)
            level.gameScenes.K356.removeImage(img)
        }
    }

    function setDisplay(text: string) {
        if (display != null) {
            display.innerHTML = text
        }
    }

    /* Überprüft ob Eingabe korrekt ist / mit einer der Easteregg eingaben übereinstimmt
        Mehr Eastereggs sind immer appreciated, yo
    */
    async function checkEingabe() {
        if (Eingabe == code) {
            gesperrt = true
            setDisplay(richtig)
            await delay(2000)

            dispatch(levelActionCreator(level, LevelActionsAction.stop))
            //easter eggs!
        } else if (Eingabe == '80085') {
            setDisplay(easterEgg_80085)
        } else if (Eingabe == '1234567') {
            setDisplay(easterEgg_1234567)
        } else if (Eingabe == '8335') {
            setDisplay(easterEgg_8335)
        } else if (Eingabe == '1337') {
            setDisplay(easterEgg_1337)
        } else {
            setDisplay(falsch)
        }
        Eingabe = ''
    }

    const tasten = [
        'taste0',
        'taste1',
        'taste2',
        'taste3',
        'taste4',
        'taste5',
        'taste6',
        'taste7',
        'taste8',
        'taste9',
        'tastee',
        'tastec',
    ]

    /* Überprüft, ob der Spieler mindest Anzahl an code - graffities gesehen hat um den Code einzugeben
        wenn die Graffities egal sind: let mind_graffities_angesehen = 0
    */
    const allowSchlossInteraction = () => {
        if (graffities_angesehen >= mind_graffities_angesehen) {
            //Schloss entfernen
            level.gameScenes.K356.hideInteractableObject('schloss')
            //Tasteneingabe erlauben
            for (const taste of tasten) {
                level.gameScenes.K356.showInteractableObject(taste)
            }
        }
    }
    allowSchlossInteraction()

    //interactable objects
    //diese Ids ändern, falls sich was mit den code - graffities ändert
    const graffiti_ids = ['graffiti', 'wand', 'hausnummer', 'graffiti_2']
    for (const id of graffiti_ids) {
        createInteractableObjectListener(
            id,
            () => {
                graffities_angesehen++

                allowSchlossInteraction()
            },
            true
        )
    }

    //Eingabe für jede Taste ermöglichen
    createInteractableObjectListener('taste1', async () => {
        eingabe('1', K356_taste_1)
    })

    createInteractableObjectListener('taste2', async () => {
        eingabe('2', K356_taste_2)
    })

    createInteractableObjectListener('taste3', async () => {
        eingabe('3', K356_taste_3)
    })

    createInteractableObjectListener('taste4', async () => {
        eingabe('4', K356_taste_4)
    })

    createInteractableObjectListener('taste5', async () => {
        eingabe('5', K356_taste_5)
    })

    createInteractableObjectListener('taste6', async () => {
        eingabe('6', K356_taste_6)
    })

    createInteractableObjectListener('taste7', async () => {
        eingabe('7', K356_taste_7)
    })

    createInteractableObjectListener('taste8', async () => {
        eingabe('8', K356_taste_8)
    })

    createInteractableObjectListener('taste9', async () => {
        eingabe('9', K356_taste_9)
    })

    createInteractableObjectListener('taste0', async () => {
        eingabe('0', K356_taste_0)
    })

    createInteractableObjectListener('tastee', async () => {
        eingabe('e', K356_taste_E)
    })

    createInteractableObjectListener('tastec', async () => {
        eingabe('c', K356_taste_C)
    })

    await AudioController.addAllToLoadingQueue()
    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    LoadingContainer.hide()
    GameSceneContainer.show()

    LevelController.startLevel(levelId)

    return new Promise<void>((resolve) => {
        addEventListener('Level', (event) => {
            // @ts-ignore
            const action: LevelActionsAction = event.detail.action
            // @ts-ignore
            const level: Level = event.detail.level

            if (action === LevelActionsAction.stop && level.id === levelId) {
                resolve()
            }
        })
    })
}
